import React from "react";
import { Dropdown } from "react-bootstrap";
import MyDropdownButton from "../Common/MyDropdownButton";
import { howtoServiceOptions } from "./HowToMonitor";

export default function ConnectTheService({ howtoService, setHowtoService }) {
  return (
    <div className="align-items-center rounded-3  p-4 bg-purple-gradient-darker-reverse px-5 mx-auto">
      <div className="mb-3">
        <span className="fs-4 fw-bold ">
          How would you like to connect to the service?
        </span>
      </div>

      <div className="mb-3">
        <Dropdown>
          <div className="d-flex">
            <Dropdown.Toggle
              id="dropdown-howto-service"
              className="bg-white text-black w-100 border-0 d-flex justify-content-between align-items-center text-start p-2 rounded-3"
            >
              {howtoService ? (
                <MyDropdownButton option={howtoService} />
              ) : (
                <div className="fw-bold text-start fs-5 ">Please select...</div>
              )}
            </Dropdown.Toggle>
          </div>

          <Dropdown.Menu className="bg-purple-gradient">
            {howtoServiceOptions?.map((o) => (
              <Dropdown.Item href="#/action-1" className="border-bottom">
                <button
                  type="button"
                  className={`btn rounded-4 w-100 text-start`}
                  onClick={(e) => {
                    e.preventDefault();
                    setHowtoService(o);
                  }}
                >
                  <div className="d-flex w-100">
                    <MyDropdownButton option={o} />
                  </div>
                </button>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}
